import { InteractionType, type PopupRequest } from "@azure/msal-browser";
import { MsalAuthenticationTemplate } from "@azure/msal-react";
import type { ReactNode } from "react";
import { LoadingScreen } from "src/components/LoadingScreen";

interface AuthenticationWrapperProps {
    children: ReactNode;
    loginRequest: PopupRequest;
}

/**
 * Wrapper component that conditionally applies MSAL authentication based on environment.
 * In test environments (detected via URL parameter), authentication is bypassed to allow
 * for predictable test execution. In production, full MSAL authentication flow is used.
 */
export function AuthenticationWrapper({ children, loginRequest }: AuthenticationWrapperProps) {
    const isTestEnvironment = window.location.search.includes("isPlaywright=true");

    // Widget and copilot routes handle their own authentication (popup-based, not redirect)
    // They use their own auth providers that work better in iframe contexts
    const isWidgetRoute = window.location.hash.includes("/widget/");
    const isCopilotRoute =
        window.location.hash.includes("/copilot") ||
        window.location.search.includes("mode=copilot");

    if (isTestEnvironment || isWidgetRoute || isCopilotRoute) {
        return <>{children}</>;
    }

    return (
        <MsalAuthenticationTemplate
            interactionType={InteractionType.Redirect}
            authenticationRequest={loginRequest}
            loadingComponent={LoadingScreen}
        >
            {children}
        </MsalAuthenticationTemplate>
    );
}
